import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  padding-top: 8px;\n'], ['\n  padding-top: 8px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', ' display: inline-block;\n  margin-bottom: 4px;\n  margin-top: 0;\n'], ['\n  ', ' display: inline-block;\n  margin-bottom: 4px;\n  margin-top: 0;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', ' font-weight: normal;\n  margin-top: 8px;\n'], ['\n  ', ' font-weight: normal;\n  margin-top: 8px;\n']);

import styled from 'styled-components';
import { typography } from '@atlaskit/theme';

/**
 * Provide a styled container for field components
 */
var FieldWrapper = styled.div(_templateObject);

/**
 * Provide a styled Label for field components
 */
export var Label = styled.label(_templateObject2, typography.h200());

/**
 * Label can appear before or after
 */
/**
 * Provide a styled container for field components
 */
export var HelperText = styled.span(_templateObject3, typography.h200());

export default FieldWrapper;